import app from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/functions"

import { navigate } from "gatsby"

// Check if code is running in browser
// Use this to ignore functions that require window (and other browser APIs) when not available
const config = {
  apiKey: "AIzaSyBDVppuPR0uTYBLwLOKLq0iR7Gnb6zy7pM",
  authDomain: "lookingforsponsor-01.firebaseapp.com",
  databaseURL: "https://lookingforsponsor-01.firebaseio.com",
  projectId: "lookingforsponsor-01",
  storageBucket: "lookingforsponsor-01.appspot.com",
  messagingSenderId: "1054218537888",
  appId: "1:1054218537888:web:e04c7f1f23521297",
}

export const isBrowser = () => typeof window !== "undefined"

export function signOut(firebaseApp, e) {
  e.preventDefault()

  if (firebaseApp) {
    firebaseApp.auth.signOut()
    navigate("/")
  }
}

export class Firebase {
  constructor() {
    if (isBrowser) {
      app.initializeApp(config)
      this.auth = app.auth()
      this.db = app.firestore()
      this.functions = app.functions()

      this.googleAuthProvider = new app.auth.GoogleAuthProvider()

      this.uiConfig = {
        signInFlow: "popup",
        signInOptions: [
          app.auth.EmailAuthProvider.PROVIDER_ID,
          app.auth.GoogleAuthProvider.PROVIDER_ID,
        ],
        tosUrl: "/legal/terms-of-service",
        privacyPolicyUrl: "/legal/privacy-policy",
        credentialHelper: "none",
        callbacks: {
          signInSuccessWithAuthResult: authResult => {
            return false
          },
        },
      }
    }
  }
}
